const Constants = {
  httpAuthToken: "bearer obfMAswessMOadBilayIivzirAppppEmaiL",
  locale_en_AE: "en-AE",
  locale_ar_AE: "ar-AE",
  verifyMemberSubPath: "#verifymember",
  updateProfileSubPath: "#updateprofile",
};
export default Constants;
